import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_APPOINTMENT_UNITS_FAILURE,
    GET_APPOINTMENT_UNITS_REQUEST,
    GET_APPOINTMENT_UNITS_SUCCESS,
} from '../constants/appointmentUnits.constants';

// Request action
const getAppointmentUnitsRequest = () => {
    return {
        type: GET_APPOINTMENT_UNITS_REQUEST,
    };
};

// Success action
const getAppointmentUnitsSuccess = (unitsData: AnyIfEmpty<object>) => {
    return {
        type: GET_APPOINTMENT_UNITS_SUCCESS,
        payload: unitsData,
    };
};

// Failure action
const getAppointmentUnitsFailure = (error: string) => {
    return {
        type: GET_APPOINTMENT_UNITS_FAILURE,
        payload: error,
    };
};

// Main action creator
export const getAppointmentUnits = (
    id: string | undefined | null,
    params?: {
        searchText?: string;
        statusFilter?: 'available' | 'unavailable' | 'all';
        page?: number;
        limit?: number;
    }
) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAppointmentUnitsRequest());
        return axios
            .get(`/admin/units/list/${id}`, {
                params: {
                    ...(params?.searchText && { searchText: params.searchText }),
                    ...(params?.statusFilter && { statusFilter: params.statusFilter }),
                    ...(params?.page && { page: params.page }),
                    ...(params?.limit && { limit: params.limit }),
                },
            })
            .then((response) => {
                dispatch(getAppointmentUnitsSuccess(response.data));
                return response.data; // Return data for pagination handling
            })
            .catch((error) => {
                dispatch(getAppointmentUnitsFailure(error?.response?.data?.message || error.message));
                throw error;
            });
    };
};

